import { apiRoutes } from 'app/globals';
import BaseRepository from 'modules/app/repositories/BaseRepository';

import * as api from 'app/lib/ajax';


export const getCompanyName = () => (
    api.get(apiRoutes.GET_COMPANY_DATA)
);


export default class ProfileRepository {

    static getCompanyName() {
        let request = new Request(apiRoutes.GET_COMPANY_DATA, {
            headers: BaseRepository.headers()
        });
        return fetch(request);

        //return fetch(apiRoutes.GET_COMPANY_DATA, {
        //    method: 'get',
        //    headers: BaseRepository.headers
        //});
            //.then(BaseRepository.parseJSON)
            //.catch(function (err) {
            //    console.error(err.toString());
            //});
    }

    //static getProfile() {
    //    let request = new Request(apiRoutes.GET_PROFILE, {
    //        headers: BaseRepository.headers()
    //    });
    //    return fetch(request);

        //return fetch(apiRoutes.GET_PROFILE, {
        //    method: 'get'
        //});
            //.then(BaseRepository.parseJSON)
            //.catch(function (err) {
            //    console.error(err.toString());
            //});
    //}

}
